import { constants } from "../../../constants";
import React from "react";

function formatSubheaders(subHeaders: string[], onClick?: () => void) {
  return (
    <div
      className={`text-sm sm:text-base bg-gray-med pl-2 self-stretch border-b-4 border-black ${
        onClick && "cursor-pointer"
      }`}
      onClick={onClick}
    >
      {subHeaders.map((s, idx) => (
        <div key={"subheader" + idx}>
          {constants.littleTriangle} {s}
          <br />
        </div>
      ))}
    </div>
  );
}

function hidden(onClick: () => void) {
  return (
    <div
      className={`text-sm sm:text-base bg-gray-med pl-2 self-stretch border-b-4 border-black cursor-pointer`}
      onClick={onClick}
    >
      <div>
        {constants.littleTriangleDown}{" "}
        <span className={"underline"}>click to show instructions </span>
      </div>
    </div>
  );
}

interface SubheaderBaseProps {
  subheaders?: string[];
  hiddenSubheaders?: boolean;
  onToggleHidden?: () => void;
}

const SubheaderBase: React.FC<SubheaderBaseProps> = ({
  subheaders,
  hiddenSubheaders = false,
  onToggleHidden,
}) => {
  const clickable = subheaders && subheaders.length > 1;

  function handleClick() {
    if (clickable && onToggleHidden) {
      onToggleHidden();
    }
  }

  function content() {
    if (!subheaders || subheaders.length === 0) {
      return "";
    }
    if (hiddenSubheaders && clickable) {
      return hidden(handleClick);
    }

    return formatSubheaders(subheaders, clickable ? handleClick : undefined);
  }

  return <>{content()}</>;
};

export default SubheaderBase;
